import { Api } from './Api';

export function* getSubject() {
    const jsonData = yield Api.get("/subjects/ss");
    return jsonData;
}